export const WINDOW_SIZE_XL = +(process.env.VUE_APP_WINDOW_SIZE_XL)
export const WINDOW_SIZE_LG = +(process.env.VUE_APP_WINDOW_SIZE_LG)
export const WINDOW_SIZE_MD = +(process.env.VUE_APP_WINDOW_SIZE_MD)
export const WINDOW_SIZE_SM = +(process.env.VUE_APP_WINDOW_SIZE_SM)
export const WINDOW_SIZE_XS = +(process.env.VUE_APP_WINDOW_SIZE_XS)
